<template>
  <el-table
    ref="table"
    class="table_box"
    :data="tableData"
    v-loading="loading"
    @selection-change="selectionChange"
    :show-summary='showSummary'
    :summary-method="getSummaries"
    size="small"
    style="width: 100%">
    <template v-for="item in columns" >
      <el-table-column
        :key="item.key"
        :prop="item.dataIndex"
        :label="item.title"
        :width="item.width"
        :type="item.type"
        :fixed="item.fixed"
        v-if="!item.slots"
        show-overflow-tooltip :selectable="ChangeSelectAble"> 
      <!-- 鼠标悬停到头部标题显示的提示信息 -->
        <template #header  v-if="item.headerTips">
          <el-tooltip effect="dark" :content="item.headerTips" placement="top">
            <span
              >{{ item.title }}<el-icon><info-filled /></el-icon
            ></span>
          </el-tooltip>
        </template>
        <!-- <template #chilren  v-if="item.type == 'expand'">
           <slot :name="item.slots" :row="scope.row"></slot>
        </template> -->
      </el-table-column>
      <el-table-column
        v-else
        :key="item.key"
        :label="item.title"
        :fixed="item.fixed"
        :width="item.width"
        :type="item.type">
        <template slot-scope="scope">
          <slot :name="item.slots" :index="scope.$index" :row="scope.row"></slot>
        </template>
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
export default {
    props:{
      // 展示那些变量
      columns:{
        type:Array,
        default() {
          return [];
        },
      },
      // 渲染表格数据
      tableData:{
        type:Array,
        default() {
          return [];
        },
      },
      // 正在加载
      loading:{
        type:Boolean,
        default:false,
      },
      
      // 选择项发生变化时会触发该事件
      // selectionChange:{
      //   type:Function,
      //   default: function () {},
      // },
      // 是否显示合计行 
      showSummary:{
        type:Boolean,
        default:false,
      },
      // 合计行数据调整
      getSummaries:{
        type:Function,
        default: function () {},
      },
      // 选择回调
      selectAble: {
        type: Boolean,
        default: false,
      },
      selectAbleA: {
        type: String,
      },
      // 设置不可选择项
      selectAbleB: {
        type: Array,
      },
    },
    data(){
        return{}
    },
    methods:{
      selectionChange(val){
        this.$emit('selectionChange',val)
        this.$emit('selectionAdd',val)
      },

      ChangeSelectAble(row, index) {

      if (this.selectAble) {
        let check = false;
        if (this.selectAbleB.length > 0) {
          this.selectAbleB.map((item) => {
            if (item == row[this.selectAbleA]) {
              check = true;
            }
          });
          return check;
        }

      }
      return true;
    },
    },
    mounted(){
        // console.log(this.columns);
        // console.log(this.tableData,55555888);
        // console.log(this.loading);
        this.$emit("getChildTable", this.$refs.table);
    }
}
</script>

<style scoped>
::v-deep thead tr .el-table__cell {
  background-color: #f2f2f2;
  color: #333333;
}

::v-deep .el-table__body tr:hover>td{
  background-color: #E8E9F0 !important;
}
::v-deep .el-table__body tr.hover-row.current-row > td,
::v-deep .el-table__body tr.hover-row.el-table__row--striped.current-row > td,
::v-deep .el-table__body tr.hover-row.el-table__row--striped > td,
::v-deep .el-table__body tr.hover-row > td {
  background-color: #E8E9F0 !important;
}
.table_box ::v-deep  .el-table__header-wrapper .el-table__header{
  min-width: 100% !important; 
}
.table_box ::v-deep  .el-table__body-wrapper .el-table__body{
  min-width: 100% !important; 
}
.table_box ::v-deep  .el-table__body-wrapper .el-table__empty-block{
  min-width: 100% !important; 
}
.table_box ::v-deep .el-table__fixed-right{
  min-height: 100% !important;
}
/* .table_box ::v-deep .el-table__cell{
   background-color: #f2f6f7 !important;
} */

.table_box ::v-deep .el-table__header .el-table__cell,.table_box ::v-deep .el-table__body .el-table__row .el-table__cell,.table_box ::v-deep .el-table__footer .el-table__cell{
  text-align: center;
}


</style>
